import React from "react";

export default function ProjectsImg({ theme }) {
  return (
    <img
      src="/programmer.svg" // المسار الجديد
      alt="Projects Section"
      style={{
        width: "100%",
        maxWidth: "1103.79px",
        height: "auto",
      }}
    />
  );
}
